import {css} from "@emotion/react";

export const root = css`
    width: 100%;
    color: white;
    height: 54px;
    font-size: 13px;
    background-color: #434864;
    opacity: 0.65;
    border: none;
    outline: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0;
    fill: white;
    cursor: pointer;

    &:hover {
        background-color: #36395f;
        opacity: 0.8;
    }
`;

export const rootSelected = css`
    opacity: 1;
    background-color: #303353;
    &:hover {
        background-color: #303353;
        opacity: 1;
    }
    cursor: default;
`;

export const iconLeft = css`
    width: 16px;
    margin-right: 16px;
`;

export const leftBorder = css`
    background-color: transparent;
    height: 100%;
    width: 6px;
`;

export const leftBorderSelected = css`
    background-color: #449DF7;
`;

export const content = css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 24px;
    flex:1;
`;